import { gql } from '@apollo/client';

export const GET_DOCUMENT_UPLOAD_URL = gql`
  mutation GetDocumentUploadUrl($input: GetDocumentUploadUrlInput!) {
    getDocumentUploadUrl(input: $input) {
      statusCode
      message
      uploadUrl
      s3Key
      contentType
      expiresIn
    }
  }
`;
